import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Menumobile from '../partils/menus/menumobile';

import Menumain from '../partils/menus/menumain';

import datahappy  from '../../local/datahappy'
// DATA -------------------------------------------------------------------------

  

export default function Tokens() {
    const initialValues ={'titulo':'','criadopor':'','data':'','hora':'',}
    const [loading,setLoading]=useState(false)
    const [modalEdit,setModalEdit]=useState(false)
    const [values,setValues]=useState(initialValues)
    const [plan,setPlan]=useState()
    function onChange(ev) {//ALTERAR OS STATES DOS INPUTS
      const {name, value} = ev.target; //ESTRAIR O NAME E VALUE DO EV
      setValues({ ...values, [name]:value }); //SETANDO O VALUE EM NAME
    }

    function Salvar(plan) {
      setModalEdit(true)
      setPlan(plan)

    }

    const final= datahappy.map(item => (
      <div key={item.id} className='w100 linha pcb7 row between'>
        <label className='w40 ml10 c4'>{item.titulo}</label>
        <label className='w20 c4'>HelloPost</label>
        <label className='w10 c4'>{item.data}</label>
        <label className='w10 c4'>{item.hora}</label>
        <label className='w10 c7 fw500 pp'>Abrir</label>
      </div>
    ))
  return(
    <div className='w100 h100 b33 row around'>
      {loading&&
      <div className='w100 h100 fundo-opaco posiabste column center'>
          <img src="https://i.pinimg.com/474x/67/d8/37/67d8379604084dd7d7c7fa8d41f4c739.jpg"></img>
      </div>
      }
      {modalEdit&&
      <div className='w100 h100 fundo-opaco posiabste column center'>
        <div className='w40 h40 b2 cont-circ7 column center cell-tamanho90'>  
          <div className='w90 column center'>
            <div className='w100 row between'>
              <h5 className='w60'>Contratar plano {plan}</h5>
              <img src='https://cdn-icons-png.flaticon.com/128/70/70287.png' 
                onClick={()=>setModalEdit(false)}
                className='pp w5 cell-tamanho10' />
            </div>
            <label className='w100 ma10b0'>Cadastre seus projetos</label>
            <div className='column w100 '>
              <label className='w100'>Titulo:</label>
              <input type='text' name='titulo'value={values.titulo} onChange={onChange}/>
            </div>
            <div className='column w100 '>
              <label className='w100'>Criado Por:</label>
              <input type='text' name='criadopor'value={values.criadopor} onChange={onChange}/>
            </div>
            <div className='row between w100'> 
              <div className='column w49 '>
                <label className='w100'>Data:</label>
                <input type='text' name='data'value={values.data} onChange={onChange}/>
              </div>
              <div className='column w49 '>
                <label className='w100'>Hora:</label>
                <input type='text' name='hora'value={values.hora} onChange={onChange}/>
              </div>
            </div>
            <div className='column w100 ma20b0'>
              <input type='submit'value='Salvar' onClick={()=>Salvar()}/>
            </div>
          </div>
        </div>
      </div>
      }

      <div className='cell-none w15'>
        <Menumain className=""/>
      </div>

      <div className='w80 h90 cont-circ7 cell-tamanho column start' >
       
        <div className='ma10b0'>
         { //<label className='fs08em'>Estamos em construção e com muitas novidades!</label>
         }
        </div>
        
        <h5 className='w95'>Tokens</h5>
      
        <div className='ma10b0 w95'>
        
        </div>
        <div className='w95 h40 b2 cont-circ7 bordaElements'>
          
          <div className='w100 h40 b2 cont-circ7 '>
            <div className='w100 linha pcb7 row between b16'>
              <label className='w40 ml10 c2 fw500 fs08em'>Titulo</label>
              <label className='w20 c2 fw500 fs08em'>Plano</label>
              <label className='w10 c2 fw500 fs08em'>Preço</label>
              <label className='w15 c2 fw500 fs08em'>Ação</label>
            </div>
            <div className='w100 linha pcb7 row between'>
              <label className='w40 ml10 c1'>Campanha de 2 Posts Mês</label>
              <label className='w20  c4'>Free</label>
              <label className='w10  c4'>0,00</label>
              <label className='w15  c7 fw500 pp' onClick={()=>Salvar('Free')}>Comprar</label>
            </div>
            <div className='w100 linha pcb7 row between'>
              <label className='w40 ml10 c1'>Campanha de 6 posts Mês</label>
              <label className='w20  c4'>Pro</label>
              <label className='w10  c4'>5,00</label>
              <label className='w15  c7 fw500 pp' onClick={()=>Salvar('Pro')}>Comprar</label>
            </div>
            <div className='w100 linha pcb7 row between'>
              <label className='w40 ml10 c1'>Campanha de 22 Posts Mês</label>
              <label className='w20  c4'>Premium</label>
              <label className='w10  c4'>39,00</label>
              <label className='w15  c7 fw500 pp' onClick={()=>Salvar('Premium')}>Comprar</label>
            </div>
            
            
          </div>
        </div>

        <div className='w95 row center h10'>
          <label className='cen c2'>
            Hello Post 2022- By Mobi Apps V.BETA
          </label>
        </div>
        <Menumobile/>
         
      </div>
    </div>
  )
}










        
